import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

export class Experts {
  static getExperts(...params) {
    return api.setUrl('project/experts').get(...params);
  }
}
